module.exports = __webpack_public_path__ + "static/media/map_domecq.82695ff3.png";